<!-- Call Header -->
<app-pathway-call-header
  [isLoading]="isLoading()"
  [title]="title"
  [showCallDetails]="shouldShowCallDetails"
  [showSettings]="!roleplayService.isPostCallVisible() && !isResultScreen()"
  [callDetails]="callDetails()"
  (settingsClicked)="handleSettingsClick()"
  (leaveStepClicked)="handleLeaveStepClick()"
  (callDetailsModalOpened)="handleCallDetailsModalOpened()"
  (callDetailsModalClosed)="handleCallDetailsModalClosed()"
>
</app-pathway-call-header>

<!-- Call Main Content -->
@if (hasDebriefError()) {
  <app-call-pathway-error />
} @else if (mainIsLoading()) {
  <div class="loading-overlay">
    <qai-loading size="large" />
  </div>
} @else if (isResultScreen()) {
  <app-call-roleplay-results
    [callUuid]="resultsCallUuid()"
    [callType]="callType"
    [stepType]="stepType"
    [moduleAssignmentUuid]="moduleAssignmentUuid"
    [realtimeCallData]="resultsCallData()"
    [realtimeService]="realtimeService"
    [controlService]="controlService"
    [callStore]="callStore"
    [userVideoService]="userVideoService"
    [deviceSettingsService]="deviceSettingsService"
    [endedEarly]="endedEarly"
    (returnToPathway)="leaveStepClicked.emit()"
    (confirmAction)="handleOnConfirmActionClick()"
    [captionsOn]="footerService.captionsOn()"
    [captionText]="captionText()"
  />
} @else {
  @if (isPreamble()) {
    <app-call-preamble
      [realtimeService]="realtimeService"
      [captionsOn]="footerService.captionsOn()"
      [captionText]="captionText()"
      [callDetails]="callDetails()"
    />
  } @else {
    <app-call-roleplay-content
      [controlService]="controlService"
      [realtimeService]="realtimeService"
      [callStore]="callStore"
      [playerService]="playerService"
      [deviceSettingsService]="deviceSettingsService"
      [hideUserVideo]="isPreamble() && stepType !== 'QUIZ'"
    />
  }
}

<!-- Pause modal -->
@if (controlService && callStore?.getIsPaused() && !deviceSettingsService?.displayModal && !controlService.isEndCallTriggered) {
  <app-call-pause
    [control]="controlService"
    [player]="playerService"
    [deviceSettings]="deviceSettingsService"
  />
}

<!-- Call Footer -->
@if (!footerService.isHidden() && !mainIsLoading() && !hasDebriefError() && !(isResultScreen() && !isStepTypePracticeCall && !roleplayService.debriefInstanceUuid() && !roleplayService.isDebriefStarting())) {
  <app-roleplay-call-footer
    (launchSimulationClicked)="handleLaunchSimulationClick()"
    (endCallClicked)="handleOnConfirmActionClick()"
  />

<!-- Exit modal -->
<app-call-roleplay-exit-modal
  [open]="showExitModal()"
  [titleKey]="exitModalTitleKey()"
  [descriptionKey]="exitModalDescriptionKey()"
  (confirmExit)="handleExitConfirmed()"
  (resume)="handleExitResumed()"
  />
}
